import PropTypes from 'prop-types';

const Building2 = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M19.125 16.25h-1.25V7.5a.625.625 0 1 0 0-1.25h-3.75v-2.5a.625.625 0 1 0 0-1.25H2.875a.625.625 0 0 0 0 1.25v12.5h-1.25a.625.625 0 1 0 0 1.25h17.5a.624.624 0 1 0 0-1.25m-2.5-8.75v8.75h-2.5V7.5zm-12.5-3.75h8.75v12.5H11V12.5a.624.624 0 0 0-.625-.625h-3.75A.625.625 0 0 0 6 12.5v3.75H4.125zm5.625 12.5h-2.5v-3.125h2.5zm-4.375-10A.625.625 0 0 1 6 5.625h1.25a.625.625 0 0 1 0 1.25H6a.625.625 0 0 1-.625-.625m3.75 0a.625.625 0 0 1 .625-.625H11a.625.625 0 1 1 0 1.25H9.75a.625.625 0 0 1-.625-.625m-3.75 3.125A.625.625 0 0 1 6 8.75h1.25a.625.625 0 0 1 0 1.25H6a.625.625 0 0 1-.625-.625m3.75 0a.625.625 0 0 1 .625-.625H11A.625.625 0 1 1 11 10H9.75a.625.625 0 0 1-.625-.625"
            fill={color}
        />
    </svg>
);

export default Building2;

Building2.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
